import React, { useEffect, useRef } from "react";
import Prism from "prismjs";
import "prismjs/themes/prism-okaidia.css";
import { stripCodeWrappers, guessLang } from "../utils/helpers";

export function CodeBlock({ code }) {
  const refCode = useRef(null);
  const cleanCode = stripCodeWrappers(code || "");
  const lang = guessLang(cleanCode);

  useEffect(() => {
    if (refCode.current) {
      Prism.highlightElement(refCode.current);
    }
  }, [cleanCode]);

  return (
    <pre className="rounded-xl overflow-x-auto bg-slate-900 p-4">
      <code className={`language-${lang}`} ref={refCode}>
        {cleanCode}
      </code>
    </pre>
  );
}
